import { Button } from "@gisce/oficina-virtual-components";
import { ButtonProps, styled } from "@mui/material";
import { FC } from "react";

const StyledFloatingButton = styled(Button)(({ theme }) => ({
  position: "fixed",
  zIndex: "999",
}));

interface IFloatingButtonProps extends ButtonProps {}

const FloatingButton: FC<IFloatingButtonProps> = (props) => {
  return <StyledFloatingButton {...props}/>;
}

export default FloatingButton;